<template lang="pug">
  form(@submit.prevent="postForm")
    div.messageArea(v-if="message") {{ message }}
    ul
      li(v-for="item in post.body" :class="`type-${item.type}`")
        div.body
          div.question-line
            span.head(v-if="item.questionnaireIndex != null") {{item.questionnaireIndex + 1 }}
            span.question(v-if="item.question" v-html="item.question")
            span.required(v-if="requiredLabel(item)") {{ requiredLabel(item) }}

          div.alert(v-if="hasAlart(item.questionnaireIndex)" class="alert") {{ requireMessage }}
          TextInput(v-if="item.type === 'text'" @getData='setData($event)' :item='item')
          Checkbox(v-if="item.type === 'checkbox'" @getData='setData($event)' :item='item')
          Select(v-if="item.type === 'select'" @getData='setData($event)' :item='item')
    div.submitArea(v-if="!post.answered")
      button.middle-button-style.blue-button(type='submit') {{ labelSend }}
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const SurveyRepository = RepositoryFactory.get('survey')
import { mapState } from 'vuex'
import { messages } from '@/const/messages'
import { labels } from '@/const/messages'
import TextInput from '@/components/Input/Text'
import Checkbox from '@/components/Input/Checkbox'
import Select from '@/components/Input/Select'
export default {
  name: 'Form',
  components: {
    TextInput,
    Select,
    Checkbox,
  },
  props: {
    post: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      formData: [],
      message: '',
      checkFrom: false,
    }
  },
  computed: {
    filteredQuestionnaire() {
      return this.post.body.filter(
        item => typeof item.questionnaireIndex !== 'undefined'
      )
    },
    fillRequired() {
      const result = this.filteredQuestionnaire.filter(
        (item, index) => this.formData[index] == null && item.required
      )
      return result.length === 0
    },
    labelSend() {
      return labels.form.send.text[this.locale]
    },
    requireMessage() {
      return messages.invalid.required_short.text[this.locale]
    },
    ...mapState({
      locale: state => state.locale,
    }),
  },
  methods: {
    setData(data) {
      this.$set(this.formData, data.index, data.value)
    },
    async postForm() {
      this.checkFrom = true
      if (!this.fillRequired) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        this.message = messages.invalid.required.text[this.locale]
        return
      }

      try {
        const data = await SurveyRepository.post(
          this.$route.params.id,
          this.post.isGeneral,
          this.formData
        )
        if (!data.succeed) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
          this.message = messages.error.unknown.text[this.locale]
          return
        }
        // アンケートの回答済みを更新したいので一覧のキャッシュを削除
        this.$store.dispatch('survey/resetItems')
        await this.$router.push({ name: 'survey-thanks' })
      } catch (error) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        this.message = messages.error.unknown.text[this.locale]
      }
    },
    hasAlart(index) {
      if (typeof index !== 'undefined') {
        return (
          this.formData[index] == null &&
          this.filteredQuestionnaire[index].required &&
          this.checkFrom
        )
      }
    },
    requiredLabel(item) {
      const label = {
        ja: '*',
        en: '*',
      }
      if (typeof item.required !== 'undefined') {
        return item.required ? label[this.locale] : ''
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
.messageArea {
  padding: 1.6em;
  color: $alert-color-red;
  background: rgba($alert-color-red, 0.1);
  margin: 0 0 2em 0;
  border-radius: 10px;
}
form {
  margin-top: 2em;
  @include sp-layout {
    margin-top: 0;
  }
}
li {
  padding: 1.6em 1.6em;
  display: flex;
  @include sp-layout {
    padding: 1.1em 1.1em;
  }
}
.head {
  font-weight: bold;
  background: #e60012;
  color: #fff;
  width: 30px;
  display: inline-block;
  text-align: center;
  height: 28px;
  border-radius: 3px;
  margin-right: 10px;
  margin-top: 3px;
  line-height: 27px;
  flex-shrink: 0;
}
.question-line {
  display: flex;
  align-items: center;
}
.question {
  font-size: 20px;
  @include sp-layout {
    font-size: 16px;
  }
}
.body {
  width: 100%;
}
.type-comment {
  margin: 17px 0 10px;
  background: $base-bg-gray-color;
}
.required {
  display: inline-block;
  margin-left: 8px;
  color: #e60012;
  font-size: 24px;
  line-height: 7px;
  height: 5px;
}
.alert {
  color: $alert-color-red;
  font-weight: bold;
  font-size: 0.85em;
  margin: 0.4em 0 0 0;
}
.submitArea {
  margin: 4em 0 0 0;
}
.blue-button {
  display: block;
  margin: 0 auto;
  &:before {
    content: none;
  }
}
</style>
